import { AnimatePresence, motion, Variants } from "framer-motion";

import styles from "./loading-dots.module.scss";

export type LoadingDotsProps = {
  loading?: boolean;
};

const itemVariants: Variants = {
  open: {
    y: [0, -5, 5, 0],
    transition: {
      repeat: Infinity,
      repeatDelay: 0.5,
    },
  },
};
export default function LoadingDots(props: LoadingDotsProps) {
  return (
    <AnimatePresence>
      {props.loading && (
        <motion.div
          className={styles.loadingWrapper}
          variants={{
            open: {
              opacity: 1,
            },
            closed: {
              opacity: 0,
            },
          }}
          transition={{ staggerChildren: 0.1 }}
          initial="closed"
          animate="open"
          exit="closed"
        >
          <motion.div className={styles.loadingDots} variants={itemVariants} />
          <motion.div className={styles.loadingDots} variants={itemVariants} />
          <motion.div className={styles.loadingDots} variants={itemVariants} />
        </motion.div>
      )}
    </AnimatePresence>
  );
}
